import React from 'react';
import { List } from 'semantic-ui-react';
import FormListItemContainer from '../../components/FormListItemContainer';

const FormObjectListItem = ({
  canEdit,
  category,
  code,
  component,
  field,
  hideLabel,
  onChange,
  showEdit,
  text,
  toolTip = 'top right',
}) => {
  if ((!canEdit && !text) || !component) {
    return null;
  }

  const FieldComponent = component.component;
  return (
    <List.Item className="aridhia-form-object-list-item">
      <FormListItemContainer
        field={field}
        hasLabel={component.hasLabel}
        hideLabel={hideLabel}
      >
        <FieldComponent
          canEdit={canEdit}
          category={category}
          code={code}
          field={field}
          showEdit={showEdit}
          text={text}
          toolTip={toolTip}
          onChange={onChange}
        />
      </FormListItemContainer>
    </List.Item>
  );
};

export default FormObjectListItem;
